import React from 'react'

import { ECodigoParametro } from '@app/enums/ECodigoParametro';
import ConfiguracaoComponent from '@app/views/Configuracao';

function CrfParametros() {
    return (
        <ConfiguracaoComponent codigo={ECodigoParametro.ContaResultadoEFechamentoDeMina} />
    )
}

export default CrfParametros;